// extracted by mini-css-extract-plugin
export default {"icon":"NavbarLinksGroup_icon__jtAbr","control":"NavbarLinksGroup_control__USr-w","link":"NavbarLinksGroup_link__B1HHU","chevron":"NavbarLinksGroup_chevron__YbI1D"};